import React, { type JSX } from 'react';
import {
  Play,
  Square,
  Settings,
  CheckCircle,
  MessageSquare,
  Zap,
  Users,
  Keyboard,
  Tag,
  Music,
  Phone,
  CircleIcon,
  ListTreeIcon,
  InfinityIcon,
  LogsIcon,
  MegaphoneIcon,
  User2Icon,
  BrainIcon,
  ArrowLeftRightIcon,
  ArchiveIcon
} from 'lucide-react';
import { FlowLogEvent } from '../../../types/flow-log';
import clsx from 'clsx';

export const getFlowLogIcon = (moduleType: string, event: FlowLogEvent): JSX.Element => {
  const isError = ['error', 'false'].includes(event.Results?.toLowerCase() ?? '');
  const iconProps = {
    className: clsx('size-3.5', !isError ? 'text-neutral-500' : 'text-red-600'),
    strokeWidth: 2.5
  };

  switch (moduleType) {
    case 'SetRecordingBehavior':
      return <ArchiveIcon {...iconProps} />;
    case 'SetWisdomAssistant':
      return <BrainIcon {...iconProps} />;
    case 'MessageParticipant':
    case 'PlayPrompt':
      return <MessageSquare {...iconProps} />;
    case 'InvokeLambdaFunction':
      return <Zap {...iconProps} />;
    case 'SetVoice':
      return <MegaphoneIcon {...iconProps} />;
    case 'GetUserInput':
      return <User2Icon {...iconProps} />;
    case 'TransferContactToAgent':
      return <Users {...iconProps} />;
    case 'Transfer':
      return <ArrowLeftRightIcon {...iconProps} />;
    case 'GetParticipantInput':
      return <Keyboard {...iconProps} />;
    case 'SetAttributes':
    case 'CheckAttributes':
    case 'SetContactAttributes':
    case 'GetContactAttributes':
      return <Tag {...iconProps} />;
    case 'SetLoggingBehavior':
      return <LogsIcon {...iconProps} />;
    case 'SetHoldMusicBehavior':
      return <Music {...iconProps} />;
    case 'SetDisconnectFlowBehavior':
      return <Phone {...iconProps} />;
    case 'FlowStart':
      return <Play {...iconProps} />;
    case 'FlowEnd':
      return <Square {...iconProps} />;
    case 'Parameters':
      return <Settings {...iconProps} />;
    case 'ExecutionResult':
      return <CheckCircle {...iconProps} />;
    case 'SetQueue':
      return <ListTreeIcon {...iconProps} />;
    case 'LoopPrompts':
      return <InfinityIcon {...iconProps} />;
    default:
      return <CircleIcon {...iconProps} />;
  }
};
